<template>
  <div class="lazy-loading">
    <img
      v-show="loaded"
      ref="backgroundImg"
      :class="customClass"
      :alt="alt"
      :src="inViewport && src"
      @load="loaded = true"
    />
    <BasePreloader v-show="!loaded" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'BaseLazyLoadingimg',
  props: {
    srcSet: {
      type: Array,
      default() {
        return []
      },
      required: true
    },
    contain: {
      type: Boolean,
      default: false
    },
    backgroundPreloaderTheme: {
      type: String,
      default: ''
    },
    customClass: {
      type: String,
      default: 'glide__img'
    },
    alt: {
      type: String,
      default: 'img'
    }
  },
  data() {
    return {
      loaded: false,
      inViewport: false
    }
  },
  computed: {
    ...mapGetters('data', ['RESOURCES_URL']),
    src() {
      if (this.isMobile) {
        return this.srcSet[0] ? this.RESOURCES_URL + this.srcSet[0] : ''
      } else if (this.isTablet) {
        return this.srcSet[1] ? this.RESOURCES_URL + this.srcSet[1] : ''
      } else if (this.isDesktop) {
        return this.srcSet[2] ? this.RESOURCES_URL + this.srcSet[2] : ''
      }
    }
  },
  mounted() {
    this.$nextTick(function() {
      if (this.$refs.backgroundImg === undefined) return

      this.observer = new IntersectionObserver(entries => {
        const image = entries[0]

        if (image.isIntersecting) {
          this.observer.disconnect()

          this.inViewport = true
        }
      }, this.intersectionOptions)

      this.observer.observe(this.$el)
    })
  },
  destroyed() {
    if (this.observer !== null && this.observer !== undefined)
      this.observer.disconnect()
  }
}
</script>

<style lang="scss">
.lazy-loading {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;

  img {
    flex-basis: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// components/_UI/BaseLazyLoadingimg.vue